import { render, staticRenderFns } from "./ConfirmSwitch.vue?vue&type=template&id=10a1b4b2&scoped=true&lang=pug"
import script from "./ConfirmSwitch.vue?vue&type=script&lang=ts"
export * from "./ConfirmSwitch.vue?vue&type=script&lang=ts"
import style0 from "./ConfirmSwitch.vue?vue&type=style&index=0&id=10a1b4b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10a1b4b2",
  null
  
)

export default component.exports